export default __webpack_public_path__ + "static/media/6.5ee6b5a7.jpg";